import React from "react";
import heroBg from "../../images/home/header-background.jpg";
import headerPicture from "../../images/home/header-picture.png";
import "./Home.css";
import homeHero from "../../data/home-hero.json";

export default function Hero() {
  return (
    <>
      <section
        className="hero-section pt-100 background-img"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-between header-cntr">
            <div className="col-md-6 col-lg-6">
              <div className="hero-content-left text-white mt-5">
                <h1 className="text-white mb-5">
                  <span>{homeHero.title}</span>
                </h1>

                {homeHero.subtitles.map((data) => (
                  <div key={data.id} className="single-feature">
                    <div className="d-flex align-items-center mb-2">
                      <span className={`${data.icon} rounded mr-3 icon`}></span>
                      <h5 className="mb-0 text-white">{data.title}</h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-6 col-lg-5">
              <div className="hero-animation-img">
                <img
                  src={headerPicture}
                  alt="Advanced Research"
                  className="hero-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
